import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ScrollText } from "lucide-react";
import { API } from "@/lib/config";
import { GoldButton } from "./fields";
import { errorMessage } from "./useMember";

export const Disclosure = ({ headers, onAccepted }) => {
  const [doc, setDoc] = useState(null);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/members/disclosure`).then((r) => setDoc(r.data)).catch(() => {});
  }, []);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/members/disclosure`, { accepted: true }, { headers });
      onAccepted(data);
    } catch (err) {
      toast.error(errorMessage(err, "Could not record your acknowledgement — try again."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="disclosure-step">
      <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
        <ScrollText size={14} /> Application disclosure
      </div>
      <p className="text-sm text-[#F5F3EF]/85 leading-relaxed mt-3 border-l border-[#D4AF37]/40 pl-4" data-testid="disclosure-text">
        {doc?.text || "Loading disclosure…"}
      </p>
      <label className="flex items-start gap-3 mt-6 cursor-pointer group" data-testid="disclosure-ack-label">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 appearance-none border border-[#D4AF37]/60 bg-[#070A0F] checked:bg-[#D4AF37] checked:border-[#D4AF37] cursor-pointer transition-colors"
          data-testid="disclosure-ack-checkbox"
        />
        <span className="text-xs text-[#94A3B8] leading-relaxed group-hover:text-[#F5F3EF] transition-colors">
          {doc?.acknowledgement || ""}
        </span>
      </label>
      <GoldButton type="button" onClick={accept} disabled={!checked || busy || !doc} className="mt-6" data-testid="disclosure-continue-btn">
        {busy ? "SAVING…" : "CONTINUE TO APPLICATION"}
      </GoldButton>
    </div>
  );
};
